const geoCode = geoCodeParams => {
    return new Promise(resolve => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(geoCodeParams).then(result => {
            const { results } = result;
            resolve(results);
        }).catch((e) => {
            console.log("Geocode was not successful for the following reason: " + e);
        });
    });
};

export { geoCode };